import { render, staticRenderFns } from "./CreateVolumeDiscountDialog.vue?vue&type=template&id=7d009771"
import script from "./CreateVolumeDiscountDialog.vue?vue&type=script&lang=js"
export * from "./CreateVolumeDiscountDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports